export default __webpack_public_path__ + "static/media/book_loader.cbf51cb4.gif";